export default {
  methods: {
    toggleISOandEUformat (date) {
      return `${date.split('-')[2]}-${date.split('-')[1]}-${date.split('-')[0]}`
    },
    checkAndTransformBirthDate (birthDate) {
      if (this.$store.state.user.role === 'admin') {
        this.SET_AVISO(`Admins can't create reservations`)
        return false
      }
      // check if the date is valid first
      if (!birthDate.split('-')[2] || birthDate.split('-').includes(undefined) || birthDate.split('-').length !== 3 || (birthDate.split('-')[0].length === 4 && isNaN(Date.parse(birthDate))) || (birthDate.split('-')[0].length < 4 && isNaN(Date.parse(this.toggleISOandEUformat(birthDate))))) {
        this.SET_AVISO(this.$store.state.option['erro-insert-valid-birth_date-' + this.lang] || 'Please insert a valid date!')
        return false
      }
      // add zeros where they are missing:
      this.birthDayFromMixin = birthDate
      if (this.$store.state.option.date_format === 'DD-MM-YYYY') {
        if (birthDate.split('-')[0].length === 4) {
          // add zeros
          this.birthDayFromMixin = `${birthDate.split('-')[0]}-${('0' + (birthDate.split('-')[1])).slice(-2)}-${('0' + birthDate.split('-')[2]).slice(-2)}`
          this.birthDayFromMixin = this.toggleISOandEUformat(birthDate)
        }
        // if we are not logged with driver, validate...
        if (!this.$store.state.user) {
          this.formattedBirthDate = this.toggleISOandEUformat(this.birthDayFromMixin)
        } else {
          if (this.$store.state.user.role === 'client') {
            this.formattedBirthDate = this.toggleISOandEUformat(this.birthDayFromMixin)
          }
          if (this.$store.state.user.role === 'driver') {
            this.formattedBirthDate = this.$store.state.user.date_of_Birth
          }
        }
      } else {
        this.formattedBirthDate = this.birthDayFromMixin
      }
      // validate whether the date is a valid date
      if (!birthDate || isNaN(Date.parse(this.formattedBirthDate))) {
        this.SET_AVISO(this.$store.state.option['erro-insert-valid-birth_date-' + this.lang] || 'Please insert a valid date!')
        return false
      }
      // validate whether the date is before today
      if (Date.parse(this.formattedBirthDate) > new Date().getTime()) {
        this.SET_AVISO(this.$store.state.option['erro-birth_date-before-today-' + this.lang] || 'Birth date must be before today')
        return false
      }
      // validate min driver's age
      let dta = new Date()
      let dateToValidateMinAge = new Date((dta.getFullYear() - (this.$store.state.option.idade_minima || 18)) + '/01/01').getTime()
      if (!(new Date(this.formattedBirthDate) > new Date('1900/01/01').getTime() && dateToValidateMinAge >= new Date(this.formattedBirthDate))) {
        this.SET_AVISO(this.$store.state.option['erro-birth_date-' + this.lang])
        return false
      }
      return true
    }
  }
}
